import type { Climate } from '@ottd/api';

import { tr } from '@/lib/locale';

/*
 * OpenTTD landscape helpers shared by the climate pictures: the game-list
 * thumbnail (ClimateThumb) and the server type tile's background.
 */

/** Human label for an OpenTTD landscape id, in the active language. */
export function climateLabel(climate: Climate | null | undefined): string | null {
  return climate === null || climate === undefined ? null : tr(`common:climate.${climate}`);
}

/** "Arctic climate" - the alt text / tooltip of a climate picture. */
export function climateCaption(climate: Climate): string {
  return tr('common:climate.label', { climate: climateLabel(climate) });
}

/** The 70×48 crop of an OpenTTD map in that landscape (public/climate/). */
export function climateSrc(climate: Climate): string {
  return `/climate/map_climate_${climate}.jpg`;
}
